module.exports = __webpack_public_path__ + "assets/img/18_1832_big.8c745704.jpg";